export default "__VITE_ASSET__CvGrIc96__"